import React, { ReactNode, useEffect } from 'react'
import styled from 'styled-components'
import SwipeableViews from 'react-swipeable-views'
import { Tab, Tabs, useMediaQuery } from '@material-ui/core'
import { styled as styling } from '@material-ui/styles'
import { FOLLOW_DIALOG_ACTIVE_TAB } from '../../atoms/profile'

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  overflow: visible;
  width: 100%;

  @media (min-width: 43em) {
    padding: 0;
  }

  @media (min-width: 62em) {
    padding: 0;
  }

  @media (min-width: 62em) {
    width: 100%;
  }
`

const SwipeDiv = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .react-swipeable-view-container {
    overflow: visible;
  }
`

const StyledTabs = styling(Tabs)({
  borderBottom: '1px solid #323232',
  // position: 'relative',
  // zIndex: -1,
  '& .MuiTabs-indicator': {
    backgroundColor: 'white',
  },
  '.MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3,
  },
})

const StyledTab = styling((props) => <Tab disableRipple {...props} />)((props) => ({
  textTransform: 'none',
  minWidth: 0,
  fontWeight: 700,
  opacity: 1,
  fontSize: props.isMobile ? (props.small ? '14px' : '18px') : props.small ? '18px' : '26px',
  textAlign: 'left',
  padding: 0,
  paddingBottom: '10px',
  marginRight:
    props.label !== '' && !props.last
      ? props.isMobile
        ? props.small
          ? '15px'
          : '25px'
        : props.small
        ? '25px'
        : '50px'
      : '0px',
  color: '#aaa',
  fontFamily: [
    'Inter',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    color: 'white',
    opacity: 1,
  },
  '&.Mui-selected': {
    color: 'white',
  },
}))

type Props = {
  columns: string[]
  children?: ((index: number, updateHeight: () => void) => ReactNode)[]
  initialTab?: number
  lastTab?: number
  small?: boolean
  left?: boolean
  tabCount?: number
  setOuterIndex?: (index: number) => void
}

const TabsContainer = ({
  small,
  columns,
  children,
  initialTab,
  lastTab,
  tabCount,
  setOuterIndex,
}: Props): JSX.Element => {
  const [index, setIndex] = React.useState(initialTab ? initialTab - 1 : 0)
  const isMobile = useMediaQuery('(max-width: 43em)')
  const isTablet = useMediaQuery('(max-width: 62em)')
  const [swipeableActions, setSwipeableActions] = React.useState<any | undefined>(undefined)

  useEffect(() => {
    if (!initialTab || initialTab === FOLLOW_DIALOG_ACTIVE_TAB.NONE) {
      return
    }

    setIndex(initialTab - 1)
  }, [initialTab])

  const handleChangeIndex = (): void => {
    setIndex(index)
  }

  React.useEffect(() => {
    setIndex(initialTab ? initialTab - 1 : 0)
  }, [tabCount])

  React.useEffect(() => {
    if (setOuterIndex) {
      setOuterIndex(index)
    }
  }, [index])

  return (
    <OuterDiv>
      <StyledTabs
        centered={false}
        value={index}
        onChange={(_e, newValue) => setIndex(newValue)}
        aria-label="ant example"
        variant={
          isMobile
            ? tabCount !== undefined && tabCount < 4
              ? 'standard'
              : 'scrollable'
            : tabCount !== undefined && tabCount < 5
            ? 'standard'
            : 'scrollable'
        }
        scrollButtons={
          isMobile
            ? tabCount !== undefined && tabCount < 4
              ? 'auto'
              : 'on'
            : tabCount !== undefined && tabCount < 5
            ? 'auto'
            : 'on'
        }
        style={{
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {columns.map((column, i) => (
          <StyledTab
            small={small}
            key={column + i}
            label={column}
            isTablet={isTablet}
            isMobile={isMobile}
            last={i === lastTab}
          />
        ))}
      </StyledTabs>
      <SwipeDiv>
        <SwipeableViews
          style={{
            width: '100%',
          }}
          axis={'x'}
          index={index}
          onChangeIndex={handleChangeIndex}
          animateHeight={true}
          action={
            ((actions: any) => {
              setSwipeableActions(actions)
            }) as any
          }
        >
          {children &&
            children.map((child) => child(index, () => swipeableActions?.updateHeight()))}
        </SwipeableViews>
      </SwipeDiv>
    </OuterDiv>
  )
}

export default TabsContainer
